import { ENV_KEYS } from "./constants";

// All experiment traffic routes to the tvgFE deployment project.
export const getDeploymentKey = (): string => ENV_KEYS.tvg.web;

export const DEPLOYMENT_KEY = getDeploymentKey();
